import {useState} from "react";
import {Box, Skeleton, Table, TableBody, TableCell, TableHead, TablePagination, TableRow} from "@mui/material";
import {CampaignRowNew} from "./CampaignRowNew";
import {CampaignCardNew} from "./CampaignCardNew";
import {paginate} from "../../../project/campaigns/utils";

const headerCellSx = {
  fontWeight: 700, fontSize: 11, py: 1, px: 1.5,
  color: "#8A8AA0", textTransform: "uppercase", letterSpacing: "0.06em",
  bgcolor: "#FAFAFD", borderBottom: "1px solid #ECECF3", whiteSpace: "nowrap",
};

const columns = ["Name", "From number", "Extension", "Dates", "Calling window", "Max attempts", "Phone numbers", "Status", "Created"];

const MessageRow = ({children}) => (
  <TableRow>
    <TableCell colSpan={columns.length + 1} align="center" sx={{py: 4, color: "#8A8AA0", fontSize: 13, border: "none"}}>
      {children}
    </TableCell>
  </TableRow>
);

const SkeletonRow = () => (
  <TableRow>
    {columns.map(column => (
      <TableCell key={column} sx={{border: "none", py: 1.25}}><Skeleton height={16} sx={{borderRadius: "6px"}}/></TableCell>
    ))}
    <TableCell sx={{border: "none"}}/>
  </TableRow>
);

const SkeletonCard = () => (
  <Box sx={{bgcolor: "#fff", border: "1px solid #ECECF3", borderRadius: "16px", p: 2.5, display: "flex", flexDirection: "column", gap: 1.5}}>
    <Skeleton height={20} width="60%" sx={{borderRadius: "6px"}}/>
    <Skeleton height={14} width="40%" sx={{borderRadius: "6px"}}/>
    <Skeleton height={60} sx={{borderRadius: "12px", mt: 0.5}}/>
    <Skeleton height={40} sx={{borderRadius: "10px"}}/>
  </Box>
);

// subProjectOf(campaign): optional label of the campaign's language (registry projects)
export const CampaignsTableNew = ({campaigns, loading, getExtension, subProjectOf, onOpen, onEdit, onDelete, viewMode = "list"}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const {currentPage, pageItems} = paginate(campaigns, page, rowsPerPage);

  return (
    <Box sx={{flex: 1, display: "flex", flexDirection: "column", overflow: "hidden"}}>
      <Box sx={{flex: 1, overflow: "auto", p: 0.5}}>
        {viewMode === "cards" ? (
          <Box sx={{display: "grid", gridTemplateColumns: {xs: "1fr", md: "repeat(2, 1fr)", xl: "repeat(3, 1fr)"}, gap: 2}}>
            {loading && campaigns.length === 0
              ? Array.from({length: 6}).map((_, index) => <SkeletonCard key={index}/>)
              : pageItems.map(campaign => (
                  <CampaignCardNew key={campaign.id} campaign={campaign} extension={getExtension(campaign.extensionId)} language={subProjectOf?.(campaign)} onOpen={onOpen} onEdit={onEdit} onDelete={onDelete}/>
                ))
            }
            {!loading && campaigns.length === 0 && <Box sx={{gridColumn: "1 / -1", py: 6, textAlign: "center", color: "#8A8AA0"}}>No campaigns yet</Box>}
          </Box>
        ) : (
          <Box sx={{bgcolor: "#fff", border: "1px solid #ECECF3", borderRadius: "16px", overflow: "auto"}}>
            <Table size="small" stickyHeader sx={{tableLayout: "auto"}}>
              <TableHead>
                <TableRow>
                  {columns.map(column => <TableCell key={column} sx={headerCellSx}>{column}</TableCell>)}
                  <TableCell padding="checkbox" sx={headerCellSx}/>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading && campaigns.length === 0
                  ? Array.from({length: 5}).map((_, index) => <SkeletonRow key={index}/>)
                  : pageItems.map(campaign => (
                      <CampaignRowNew key={campaign.id} campaign={campaign} extension={getExtension(campaign.extensionId)} language={subProjectOf?.(campaign)} onOpen={onOpen} onEdit={onEdit} onDelete={onDelete}/>
                    ))
                }
                {!loading && campaigns.length === 0 && <MessageRow>No campaigns yet</MessageRow>}
              </TableBody>
            </Table>
          </Box>
        )}
      </Box>
      <TablePagination
        component="div"
        count={campaigns.length}
        page={currentPage}
        onPageChange={(e, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(0);
        }}
        rowsPerPageOptions={[10, 25, 50]}
        sx={{color: "#6B6B80"}}
      />
    </Box>
  )
}
